module.exports = "https://redage.akamaized.net/src/views/player/help/images/2472.jpg";